import { Component } from '@angular/core';
import {AlertController, App, Events, IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {AppVideoPlayerPage} from "../app-video-player/app-video-player";
import {AppDashboardPage} from "../app-dashboard/app-dashboard";
import {CourseModule} from "../../models/course-module";
import {CourseVideo} from "../../models/course-video";
import {AppVideoQuizPage} from "../app-video-quiz/app-video-quiz";
import {AppVideoMyWayPage} from "../app-video-my-way/app-video-my-way";
import {UserProgressStateProvider} from "../../providers/user-progress-state/user-progress-state";
import {UserStatsProvider} from "../../providers/user-stats/user-stats";
import {UserStats} from "../../providers/api-course-data/user-state-dto";
import {AppStepUpdatePage} from "../app-step-update/app-step-update";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {StepCounterEngineProvider} from "../../providers/step-counter-engine/step-counter-engine";

/**
 * Generated class for the AppVideoDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-video-details',
  templateUrl: 'app-video-details.html',
})
export class AppVideoDetailsPage {
  moduleVideoDetailsPage: any = AppVideoPlayerPage

  video: CourseVideo;
  currentVideo: boolean = false;
  syncAvailable: boolean = false;
  stats: UserStats;
  moodDetails: Map<number, string>;
  syncSwitchSubscription: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, private app: App, public progressProvider: UserProgressStateProvider, private statsProvider: UserStatsProvider, public userState: UserStateProvider, public stepCounterEngine: StepCounterEngineProvider, public loadingCtrl: LoadingController, public event: Events) {
    if(!this.navParams.data) {
      this.navCtrl.push(AppDashboardPage)
    }
    console.log(this.navParams);
    this.video = (this.navParams.data as CourseVideo);
    this.currentVideo = (this.video._userStatus == 2);

    this.moodDetails = new Map<number, string>();
    this.moodDetails.set(1, 'schlecht');
    this.moodDetails.set(2, 'nicht gut');
    this.moodDetails.set(3, 'ok');
    this.moodDetails.set(4, 'gut');
    this.moodDetails.set(5, 'super');

    this.stats = new UserStats();
    var me = this;
    this.statsProvider.getUserStats(this.video._userDate).then(st => {
      me.stats = st;
    });

    this.syncSwitchSubscription = function() {
      console.log('switch', me.userState.user.stepCounterEngine)
      me.syncAvailable = false;
      me.stepCounterEngine.getEngine(me.userState.user.stepCounterEngine).syncAvailable().then((res: boolean) => {
        me.syncAvailable = res;
      })
    }

    this.event.subscribe('app:step-counter-engine-update', this.syncSwitchSubscription);
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad AppVideoDetailsPage');

    var me=this;
    this.statsProvider.getUserStats(this.video._userDate).then(st => {
        me.stats = st;
        console.log(me.stats);
    });

    this.stepCounterEngine.getEngine(this.userState.user.stepCounterEngine).syncAvailable().then((res: boolean) => {
      me.syncAvailable = res;
    })

  }

  ionViewDidLeave() {
    this.event.unsubscribe('app:step-counter-engine', this.syncSwitchSubscription);

  }

  sync() {
    if(!this.syncAvailable) {
      return ;
    }

    var loader = this.loadingCtrl.create({
        content: 'Syncing'
    });
    loader.present();

    this.stepCounterEngine.getEngine(this.userState.user.stepCounterEngine).makeSync(this.video._userDate).then(res => {
      loader.dismissAll();
    }).catch(err => {
      console.log(err)
      loader.dismissAll();
    })
  }

  openVideo() {
    this.app.getRootNav().push(AppVideoPlayerPage, this.video);
  }

  openStepUpdate() {
    this.app.getRootNav().push(AppStepUpdatePage, {date: this.video._userDate})
  }

  openQuiz() {
    this.app.getRootNav().push(AppVideoQuizPage, this.video);
  }
  openMyWay() {
    this.app.getRootNav().push(AppVideoMyWayPage, this.video, {animate: false})
  }

  updateMood(mood: number) {
    this.stats.mood = mood;
    this.statsProvider.updateData(this.stats)
  }
}



// WEBPACK FOOTER //
// ./src/pages/app-video-details/app-video-details.ts